import { observer } from 'mobx-react-lite'

import { DatePicker, Input, SexButtons } from 'components'
import { useValueContext } from 'contexts'

interface Props {
  onChange: (field: string) => (value: string) => void
  enableTabIndex?: boolean
}

export const Step1 = observer(({ enableTabIndex, onChange }: Props) => {
  const { settings } = useValueContext()

  return (
    <>
      <div className="sex-subheader">Укажите пол вашего ребенка:</div>
      <SexButtons selected={settings.gender} onChange={onChange('gender')} />
      <div className="step1-input-wrapper">
        <label className="label">
          <span>Имя вашего ребенка</span>
        </label>
        <Input
          className="input"
          value={settings.name}
          onChange={onChange('name')}
          tabIndex={enableTabIndex ? 0 : -1}
          scrollToOnFocus
        />
      </div>
      <div className="step1-input-wrapper birthdate">
        <label className="label">
          <span>Дата рождения</span>
          <DatePicker
            className="input"
            value={settings.birthDate}
            onChange={onChange('birthDate')}
            tabIndex={enableTabIndex ? 0 : -1}
            scrollToOnFocus
          />
        </label>
      </div>
    </>
  )
})
